import { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import LoginView from './loginView';
import OtpView from './otpView';
import ProfileVersion from "../profile/profileVersion";

const LoginFormLayout = ({
    contactAdmin
}) => {
    const [showLoginView, setShowLoginView] = useState(true);

    useEffect(() => {
        const encryptedAuthData = sessionStorage.getItem('authSession');

        if(encryptedAuthData){
            setShowLoginView(false);
        }
    }, []);

    return (
        <>
            {
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    height='100vh'
                    px={{xs: 3, md: 0}}
                >
                    {
                        showLoginView
                        ?
                        <LoginView 
                            contactAdmin={contactAdmin}
                            showOtpView={() => setShowLoginView(false)}
                        />
                        :
                        <OtpView 
                            back={() => setShowLoginView(true)}
                        />
                    }

                    <ProfileVersion />
                </Stack>
            }
        </>
    );
}

export default LoginFormLayout;